export default __webpack_public_path__ + "static/media/Lynette_Lee.8ea9600a.jpg";